import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center p-6">
      <div className="bg-white border border-[#E5E5E5] rounded-2xl p-10 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 text-[#5C5C5C] mx-auto" />
        <h1 className="font-display font-bold text-2xl text-[#0A2E26] mt-5">Payment cancelled</h1>
        <p className="text-[#5C5C5C] mt-2">No charge was made. You can invest anytime.</p>
        <Button data-testid="back-dashboard-btn" onClick={() => navigate("/dashboard")}
          className="mt-6 bg-[#0A2E26] hover:bg-[#07201A] text-white rounded-md h-11 px-7">
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}
